/* eslint-disable no-console */
import PropTypes from 'prop-types';
import Link from 'core/components/Link';
import { useEffect, useState } from 'react';

import { getCookie } from '../../../utils/cookie-helper';

import withoutSSR from 'core/components/withoutSSR';
import styles from './index.styl';

const QuickEditLink = ({ topicId }) => {
  const [edTopicBaseUrl, setEdTopicBaseUrl] = useState(null);

  useEffect(() => {
    setEdTopicBaseUrl(getCookie('ed_topics_redirects_base_url'));
  }, []);

  if (!edTopicBaseUrl) return null;

  return (
    <Link
      to={`${edTopicBaseUrl}/${topicId}`}
      className={styles.container}
      type='blank'
    >
      <div className={styles.pencil} />
    </Link>
  );
};

QuickEditLink.propTypes = {
  topicId: PropTypes.string.isRequired,
};

const QuickEditLinkWithHOCs = withoutSSR(QuickEditLink);
QuickEditLink.displayName = 'QuickEditLink';

export { QuickEditLink as StorybookComponent };
export default QuickEditLinkWithHOCs;
